import { StandardInput } from "@/components/ui/forms/standardInput"
import { type SimpleFormik } from "@/typings/formik"
import { type BoxFormikType, type BoxInputKey } from "@modules/box/boxFormikType"
import { BoxFormTemplatePage } from "@modules/box/components/boxCreationForm/boxFormTemplatePage"
import { word } from "@modules/core/utils/i18n"

export type BoxFormPageProps = {
  handleSubmit: () => void
  onPrevious: () => void
  formik: SimpleFormik<BoxFormikType, BoxInputKey>
  isSubmitting: boolean
  getFormErrorMessage: (name: BoxInputKey, errorMessage?: string) => React.JSX.Element | undefined
  disabled: boolean
}

export const BoxFormFirstPage = ({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
}: BoxFormPageProps) => {
  return (
    <BoxFormTemplatePage
      onPrevious={onPrevious}
      handleSubmit={handleSubmit}
      disabled={disabled}
      pageNumber={1}
      header={{
        title: word("box.creation.page.1.title"),
        subtitle: word("box.creation.page.1.subtitle"),
      }}
    >
      <StandardInput
        name="name"
        isRequiredInput
        label={word("box.form.name.label")}
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("name")}
        inputProps={{
          className: "w-full",
        }}
      />
    </BoxFormTemplatePage>
  )
}
